import { render, staticRenderFns } from "./AcademicStatusesIndex.vue?vue&type=template&id=7d0ac102"
import script from "./AcademicStatusesIndex.vue?vue&type=script&lang=js"
export * from "./AcademicStatusesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports